import React, { useState, useEffect } from 'react';
import Hosts from '../../Hosts'
import {reqPOST, reqGET, passwordHash, repo_banner_link, set_language} from '../../Utils'

import Modal from "react-modal";

import { language } from '../WEBContent/Language';

import { confirmAlert } from 'react-confirm-alert';
//import { getTokenInfo } from '../../UseToken';


Modal.setAppElement("#root");

const LoginForm = (props) => {
  /*  async function loginUser(credentials) {
     return fetch(Hosts.SIMCore_API + '/' + props.loginType, {
       //return fetch(Hosts.SIMCore_API+'/auth/'+props.loginType, {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(credentials)
     })
       .then(data => data.json())
     //.then(res =>res.token) */

  const [lang, set_lang] = useState('pt');

  const [/*companycode,*/ setCompanyCode] = useState('');
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [password_recovery, setPasswordRecovery] = useState('');

  const [input_type, setInputType] = useState('password');

 
  const [link_final, /*set_link_final*/] = useState(Hosts.EMAIL_WEB_SITE_URL);

  const change_lang = (l) => {
      set_language(l)
      set_lang(l)
      //window.location.reload()

      //console.log('language login form', localStorage.getItem('lang'))
      //console.log('localstorage login form', localStorage)
  }

useEffect(() => {

    if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
        change_lang('pt')
    }
    else {
        set_lang(localStorage.getItem('lang'))
        //console.log('aki login form', localStorage)
    }


}, [])

  const handleSubmit = e => {
    //e.preventDefault();
    /*  const objToken = await loginUser({
       companycode,
       username,
       password: Utils.passwordHash(password)
     }); */

    //PASSWORD -> MD5
    //console.log('Token:' + crypto.createHash('md5').update('hftpaak17').digest("hex"));

    //console.log('Token:' + objToken);
    //console.log(JSON.stringify(objToken))

    e.preventDefault();
    localStorage.clear();
    
    change_lang(lang)

    reqPOST(Hosts.SIMCore_API + '/' + props.loginType, {
      companycode: Hosts.companycode,
      //companycode,
      username,
      password: passwordHash(password)
    }).then(objToken => {
      if (objToken.token !== false) {


        

        //console.log('SETOU->', objToken)
        props.setToken(objToken);
       // console.log(JSON.stringify(objToken))
        //alert('Autenticado!')
        
        /*  confirmAlert({
           title: 'SIM.Credit.Net',
           message: 'Sistema de Gestão de Créditos',
           buttons: [
             {
               label: 'Entrar',
               onClick: () => { */
        //console.log(objToken.user_info[0].profile.name)

        //console.log('COMAPNY-CODE: ' + objToken.user_info[0].info.companycode)
        //localStorage.setItem('companycode', companycode);
        //localStorage.setItem('companycode', companycode);
        /*  localStorage.setItem('username', objToken.user_info[0].info.name);
         localStorage.setItem('companycode', objToken.user_info[0].info.companycode);
 
         localStorage.setItem('profile', objToken.user_info[0].profile.name);
         localStorage.setItem('user_info', objToken.user_info[0]); */

        // if (getTokenInfo().companycode === companycode) {

        //}
        //props.history.push('/')
        /*  }
       }
  
     ]
   });
  */
      }
      else {
        confirmAlert({
          title: language[lang].failed_login,
          message: language[lang].incorrect_login_data,
          buttons: [
            {
              label: language[lang].back,
              onClick: () => { return }
            }

          ]
        });
        //alert('Não Autenticado');
        localStorage.clear();
        //setToken(token);
      }
    })
  }

	const [isOpen, setIsOpen] = useState(false);

  function toggleModal() {
		setIsOpen(!isOpen);
	}

  const togglePwd = async e => {
    if (input_type.localeCompare('text') === 0)
      setInputType('password');
    else
      setInputType('text');
  }

  const sendRecovery = async () => {
    await reqGET(Hosts.SIMCore_API + '/entities/password/recovery/'+ Hosts.companycode + '/' + password_recovery)
      .then(res => {
        //console.log(res)

        if(res.status === 200) {
          let link_aux = link_final + '/form_recovery/' + res.data

          let mailOptions = {
            from: Hosts.contactFrom,
            // vários emails separados por virgulas
            //to: web.dev@assec.pt',
            to: password_recovery,
            //cc-> opcional
            //cc: Hosts.contactFrom,
            subject: Hosts.webSiteTitle + ' - ' + language[lang].contact_recovery,
            //text: 'Teste de EMAIL ', -> opcional
            html:
      
                '<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
                    '<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
                        '<tr style="border-collapse: collapse;">' +
                            '<td style="border-collapse: collapse;">' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
                                            '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
                                                '<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
                                            '</a>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="540" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 540px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" class style="padding:0 0 10px; border-collapse:collapse;">' +
                                            '<div style="width:540px; margin: 0 auto; padding-left: 30px; padding-right: 30px;">'+
                                                '<h4 style="text-transform: uppercase;">'+ language[lang].contact_recovery +':</h4>'+
                                                '<span><label>' + language[lang].password_recover + '</label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<span><label>' + language[lang].password_recover_2 + ' <a href="'+ link_aux +'" alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '">' + language[lang].recover_password + '</a></label></span>'+
                                                '<br/>'+
                                                '<br/>'+
                                                '<span><label>' + language[lang].password_recover_3 + '</label></span>'+
                                            '</div>'+
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                                '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
                                    '<tr style="border-collapse: collapse;">' +
                                        '<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
                                            '<div style="margin: 0 auto; width:600px;">'+
                                                '<div style="text-align: center; font-size: small; color: #FFFFFF;">'+
                                                    '<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>'+
                                                    '<br/>'+
                                                    '<span>' + Hosts.webSiteAdress + '</span>'+
                                                    '<br/>'+
                                                    '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="text-decoration:none;"> '+
                                                        '<span style="color: #FFFFFF;" >'+ Hosts.EMAIL_WEB_SITE_URL +'</span>' +
                                                    '</a>'+
                                                '</div>'+
                                            '</div>' +
                                        '</td>' +
                                    '</tr>' +
                                '</table>' +
                            '</td>' +
                        '</tr>' +
                    '</table>' +
                '</div>',
          }; 

          reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
            .then(() => { 

              toggleModal()

              confirmAlert({
                title: language[lang].submitted_application,
                message: language[lang].email_recover_pass,
                buttons: [
                  {
                    label: language[lang].back,
                    onClick: () => { return }
                  }
      
                ]
              });

            })
            .catch((error) => console.log(error)/*alert('Problema ao enviar notificações!')*/)
        }
        else {
          confirmAlert({
            title: language[lang].incorrect_request,
            message: language[lang].email_recover_pass_2,
            buttons: [
              {
                label: language[lang].back,
                onClick: () => { return }
              }
  
            ]
          });
        }

        // TODO 
        // Enviar email com link + hash

        /*
        reqPOST(Hosts.SIMCore_API + '/entities/password_recovery/', {recovery_hash: res.data, new_password: passwordHash('cunha#2025')})
          .then(res => {
            console.log(res)
    
            // TODO 
            // Enviar email com link + hash
    
          })
          .catch(() => 404)
          */

      })
      .catch(() => 404)
  }

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div className="form-group d-none">
        <h3 className="assec-my-25">{language[lang].welcome}</h3>
        <label>
          <label>{language[lang].code}</label>
          <input type="text" className="form-input" name='companycode' value={Hosts.companycode} onChange={(e) => setCompanyCode(e.target.value)} />
        </label>
      </div>
      <div className="form-group">
        <label>{language[lang].username}</label>
        <input type="text" className="form-input" name='username' value={username} onChange={(e) => setUserName(e.target.value)} />
      </div>
      <div className="form-group">
        <label>{language[lang].password}</label>
        <input type={input_type} className="form-input input-pwd" value={password} onChange={(e) => setPassword(e.target.value)} />
        <img alt='' onClick={togglePwd} src={ input_type === 'password' ? './img/view.svg' : './img/view_password.svg'} />
      </div>
      
      <div className="form-group">
        <button className="form-button btn-primary mt-3" type="submit">{language[lang].login}</button>
      </div>


      <div className="form-group assec-mb-0 d-none">
        <a href={Hosts.WEB_SITE_URI + 'form_author'} rel="noreferrer" target="_blank">{language[lang].register_here}!</a>
      </div>
      <div className="form-group">
        <button type="button" onClick={toggleModal} className="text-center w-100 small">{language[lang].recover_password}!</button>
      </div>
    </form>

    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel={language[lang].recover_password}
      className="mymodal div-right"
      overlayClassName="myoverlay"
      closeTimeoutMS={500}
    >
      <div className="assec-text-right">
        <button alt={language[lang].close} title={language[lang].close} onClick={toggleModal}><i className="bi bi-x-lg"></i></button>
      </div>
      <div className="div-modal">
        <div className="modal-body modal-modal">
            <h4 className='dash-title'>{language[lang].recover_password}</h4>
            <div className="form-group assec-mt-30">
              <input type="email" className="form-input" id='email-modal-recuperacao' placeholder={language[lang].email_placeholder} name='email' onChange={(e) => setPasswordRecovery(e.target.value)} />
            </div>
            <div className="form-group assec-mt-30">
              <button type="button" className="form-button btn-primary" onClick={() => sendRecovery()}>{language[lang].send}</button>
            </div>
          </div>
      </div>
    </Modal>
    </>
  );


}

/*
LoginForm.propTypes = {
    setToken: PropTypes.func.isRequired
  };
*/

export default LoginForm;
